import { Badge } from "@/components/ui/badge";
import { Progress } from "@/components/ui/progress";

function getHeatmapColor(percent) {
  if (percent === 0) return '#f1f5f9';
  if (percent <= 30) return '#bbf7d0';
  if (percent <= 60) return '#86efac';
  if (percent <= 80) return '#fde047';
  if (percent <= 100) return '#fb923c';
  return '#ef4444';
}

const CapacityView = ({ resources, scheduleData }) => {
  if (!resources.length) return <p className="text-sm text-muted-foreground text-center py-4">No resources loaded</p>;
  const capacityByResource = {};
  (scheduleData.capacity_summary || []).forEach(c => {
    if (!capacityByResource[c.resource_id]) capacityByResource[c.resource_id] = [];
    capacityByResource[c.resource_id].push(c);
  });

  return (
    <div className="space-y-4" data-testid="capacity-view">
      {resources.map((resource) => {
        const loads = capacityByResource[resource.id] || [];
        const avgUtil = loads.length > 0 ? loads.reduce((sum, ld) => sum + ld.utilization_percent, 0) / loads.length : 0;
        const maxUtil = loads.length > 0 ? Math.max(...loads.map(ld => ld.utilization_percent)) : 0;
        const overloadedDays = loads.filter(ld => ld.overloaded).length;
        return (
          <div key={resource.id} className="p-4 border rounded-lg">
            <div className="flex items-center justify-between mb-2">
              <div>
                <p className="font-medium text-sm">{resource.name}</p>
                <p className="text-xs text-muted-foreground">{resource.id} &middot; {resource.capacity_per_day}h/day</p>
              </div>
              <div className="text-right flex items-center gap-4">
                <div><p className="text-sm font-bold">{avgUtil.toFixed(1)}%</p><p className="text-[10px] text-muted-foreground">Avg</p></div>
                <div><p className="text-sm font-bold">{maxUtil.toFixed(1)}%</p><p className="text-[10px] text-muted-foreground">Peak</p></div>
                {overloadedDays > 0 && <Badge variant="destructive" className="text-xs">{overloadedDays}d overloaded</Badge>}
              </div>
            </div>
            <Progress value={Math.min(avgUtil, 100)} className={`h-2 ${avgUtil > 100 ? 'bg-red-200' : ''}`} />
            {loads.length > 0 && (
              <div className="flex gap-px mt-2" title="Daily utilization heatmap">
                {loads.slice(0, 30).map((ld, i) => (
                  <div key={i} className="flex-1 h-3 rounded-sm" style={{ backgroundColor: getHeatmapColor(ld.utilization_percent), minWidth: 4, maxWidth: 16 }} title={`${ld.date}: ${ld.utilization_percent.toFixed(0)}%`} />
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default CapacityView;
